module.exports = "<p>\n  layout works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = ./src/app/layout/layout.component.html
// module chunks = main